import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function AddressSearch({ onPick }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [lastId, setLastId] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    if (q.trim().length < 3) { setItems([]); return undefined; }
    const ctl = new AbortController();
    const tm = setTimeout(() => {
      api.get("/address/find", { params: { q, last_id: lastId }, signal: ctl.signal })
        .then((r) => { setItems(r.data.items); setErr(""); })
        .catch((e) => { if (e.name !== "CanceledError") setErr("Suggestions indisponibles : saisissez l'adresse ci-dessous."); });
    }, 280);
    return () => { clearTimeout(tm); ctl.abort(); };
  }, [q, lastId]);
  const choose = async (s) => {
    if (s.next === "Find") { setLastId(s.id); setQ(`${s.text} `); return; }
    try {
      const { data } = await api.post("/address/retrieve", { id: s.id });
      onPick(data.address); setItems([]); setQ(s.text); setLastId("");
    } catch { setErr("Adresse introuvable, saisissez-la ci-dessous."); }
  };
  return (
    <div className="sm:col-span-2 relative" data-testid="address-search">
      <label className="block"><span className="label-xs">Rechercher votre adresse (Postes Canada)</span>
        <input data-testid="address-search-input" value={q} onChange={(e) => { setQ(e.target.value); if (!e.target.value) setLastId(""); }} autoComplete="off"
          placeholder="Ex. 1325 place de l'Hôtel-de-Ville, Trois-Rivières" className="mt-1.5 w-full border border-black/10 bg-transparent px-3 py-2.5 text-sm" />
      </label>
      {items.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full bg-[#FBF8F2] border border-black/10 shadow-lg max-h-72 overflow-auto" data-testid="address-suggestions">
          {items.map((s, i) => (
            <li key={s.id}><button type="button" data-testid={`address-suggestion-${i}`} onClick={() => choose(s)} className="w-full text-left px-3 py-2 text-sm hover:bg-black/5 transition-colors">
              {s.text} <span className="block text-xs text-muted-foreground">{s.description}</span></button></li>
          ))}
        </ul>
      )}
      {err && <p className="text-xs text-muted-foreground mt-1" data-testid="address-search-error">{err}</p>}
    </div>
  );
}
